<script setup lang="ts">
import MAvatar from "./../MAvatar";
import MLayoutStack from "../MLayoutStack/MLayoutStack.vue";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps<{
  name?: string;
  description?: string;
  footer?: {
    text?: string;
    date?: string;
    dateTime?: string;
  };
  staff?: {
    name: string;
    initials: string;
    photoUrl: string;
    type: string;
  };
  photoUrl?: string;
  selected?: boolean;
  isUnread?: boolean;
}>();

defineEmits({
  click: () => true,
});
</script>
<template>
  <div class="m-inbox-item" :class="{ selected }" role="button" @click="$emit('click')">
    <m-layout-stack class="overflow-hidden" full gap="1">
      <div class="flex align-items-center gap-2">
        <m-avatar
          v-if="staff"
          :name="staff?.name"
          :initials="staff?.initials"
          :photo-url="staff?.photoUrl || photoUrl"
          data-testid="assignee-avatar"
          size="30px"
        />
        <span class="name">{{ name }}</span>
      </div>
      <div v-if="description" class="description" v-text="description" />
      <slot v-bind="$props" />
    </m-layout-stack>

    <m-layout-stack horizontal class="badges-container" gap="0">
      <div
        v-if="isUnread"
        data-testid="unread"
        class="unread"
        aria-label="unread"
        aria-hidden="false"
      >
        <i class="fa-solid fa-circle fa-xs status-green" />
      </div>
    </m-layout-stack>
  </div>
</template>
<style lang="scss">
.unread {
  color: var(--status-green);
}
.m-inbox-item {
  padding: 10px 8px 8px 12px;
  border: 1px solid var(--border-colour);
  border-right: none;
  border-top: none;
  border-left: none;
  font-size: 14px;
  line-height: 150%;
  color: var(--grey-darkest);

  display: flex;

  .medicus-avatar {
    flex: 0 0 auto;

    align-self: flex-end;
  }
  &:hover {
    cursor: pointer;
    background: #ebedef;
  }
  &.selected {
    background: var(--grey);
  }
  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    align-content: center;
    // margin-bottom: 3px;
    color: var(--text-color);

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .description {
    margin-bottom: 3px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-family: Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.01em;

    color: var(--grey-darkest);
  }
  .badges-container {
    align-items: center;
  }
  .status-green {
    color: var(--status-green);
  }
}
</style>
